"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBellFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M11.19 26A4.51 4.51 0 0016 30a4.57 4.57 0 004.81-4zM29 20.65l-.55-.28C26.29 19.28 25 16.71 25 13.51v-1.23C25 6.29 21.8 3 16 3s-9 3.38-9 9.28v1.23c0 3.15-1.32 5.78-3.45 6.86l-.55.28V24h26z" })));
}
exports.default = SvgBellFilled;
//# sourceMappingURL=BellFilled.js.map